import { SxProps, Theme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface ICustomIcon extends Omit<SvgIconProps, "children"> {
    icon: JSX.Element;
    sx?: SxProps<Theme>;
}

const CustomIcon = ({ icon, ...otherProps }: ICustomIcon) => {
    return (
        <SvgIcon component="svg" {...otherProps}>
            <g fill="currentColor">{icon}</g>
        </SvgIcon>
    );
};

export default CustomIcon;
